"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slideAsset = _interopRequireDefault(require("./slideAsset"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/* eslint-disable implicit-arrow-linebreak */

/**
 * Schema for a Slide
 * @param {ObjectId} objectIdType ObjectId type from mongoose package
 * @returns Array with Collection name and defined Schema
 */
var Slide = function Slide(objectIdType) {
  if (!objectIdType) {
    throw new Error('objectIdType must be provided');
  }
  return ['Slide', {
    name: {
      type: String,
      required: true,
      minlength: 1,
      maxlength: 500,
      trim: true
    },
    _moduleId: {
      type: objectIdType,
      ref: 'Module'
    },
    // For linking to a source slide
    linkId: {
      type: objectIdType
    },
    type: {
      type: String,
      required: true
    },
    subType: {
      type: String
    },
    instructions: {
      type: String
    },
    createdAt: {
      type: Date,
      required: true
    },
    createdBy: {
      type: String
    },
    updatedAt: {
      type: Date
    },
    updatedBy: {
      type: String
    },
    disabledAt: {
      type: Date
    },
    active: {
      type: Boolean,
      "default": true
    },
    dirty: {
      type: Boolean,
      "default": false
    },
    published: {
      type: Boolean,
      "default": false
    },
    report: {
      type: String
    },
    order: {
      type: Number
    },
    tags: [{
      type: objectIdType,
      ref: 'Tag'
    }],
    adaptive: {
      type: String,
      "default": 'NOT_ADAPTIVE'
    },
    hideExcerptLabel: {
      type: Boolean
    },
    excerptPosition: {
      type: String
    },
    isSingle: {
      type: Boolean
    },
    // Came from specific template-slides
    layout: {
      type: String
    },
    panels: [{
      width: {
        type: Number,
        required: true
      }
    }],
    answerPanelFirst: {
      type: Boolean,
      "default": false
    },
    timeline: [(0, _slideAsset["default"])(objectIdType)],
    // For CheckAllApply, ChooseBestProvision, ClickBestSpot
    tries: {
      type: Number
    },
    // For Explanation Slide
    duration: {
      type: Number
    },
    audioId: {
      type: objectIdType,
      ref: 'Resource'
    },
    treatAsExercise: {
      type: Boolean
    },
    // For ClickBestSpot
    enableParagraphMarks: {
      type: Boolean,
      "default": false
    },
    paragraphSelection: {
      type: Boolean,
      "default": false
    },
    // For CheckAllApply Tri-Panel
    referenceContentId: {
      type: objectIdType,
      ref: 'Resource'
    },
    // For CheckAllApply Edit Vertical
    hidePreviewCaret: {
      type: Boolean,
      "default": false
    }
  }];
};
var _default = Slide;
exports["default"] = _default;